module.exports = __webpack_public_path__ + "2d66dc977e04061bb70f604db99c1838.jpg";